import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IAssembly } from 'src/interfaces';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';

export const useCreateAssemblyVariation = () => {
  return useMutation({
    mutationFn: createAssemblyVariation,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceEligibleAssemblyIds.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.scheduleAssembliesSearch.invalidateAll(),
      );
    },
  });
};

const createAssemblyVariation = async (payload: Partial<IAssembly>) => {
  const data = {
    name: payload.name,
    status: payload.status,
    layout_id: payload.layout_id,
    variation_parent_id: payload.variation_parent_id,
  };

  const response = await requestCCApi({
    url: `/assemblies`,
    method: 'POST',
    data: { data: data },
  });

  return response;
};
